import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { AccountService } from '../../users/data/services/account.service';
import { ViewOutstationComponent } from '../view-outstation/view-outstation.component';
import { TokenStorageService } from 'src/app/core/service/token-storage.service';
import { LevelNameService } from 'src/app/authentication/otp/level-name.service';
@Component({
  selector: 'app-add-outstation',
  templateUrl: './add-outstation.component.html',
  styleUrls: ['./add-outstation.component.sass']
})
export class AddOutstationComponent implements OnInit {

  isSuccessful = false;
  isUploadFailed = false;
  errorMessage = "";

  action: string;
  dialogTitle: string;
  //employeesForm: FormGroup;
  sender: any;

  Data?: any;
  message?: any;
  addStationForm!: FormGroup;
  childLevelLabel: string; 

  //categorys = [{ name: "Company" }, { name: "Individual" }];

  selectFeedback: " ";

  constructor(
    private deptService: AccountService,
    private fb: FormBuilder, private snackbar: SnackbarService,
    public dialogRef: MatDialogRef<ViewOutstationComponent>,
    private tokenStorage: TokenStorageService,
    private levelNameService: LevelNameService,
    @Inject(MAT_DIALOG_DATA) data
  ) 
  {
    this.Data = data.test;
    //console.log("The data = " + this.Data);
  }
  formControl = new FormControl("", [
    Validators.required,
    // Validators.email,
  ]);

  ngOnInit(): void {
    this.addStationForm = this.createForm();
    this.dialogTitle = "Add Outstation";

      const levelNames = this.levelNameService.getLevelNames();
  console.log('Level names returned:', levelNames);

  if (levelNames) {
    // this.parentLevelLabel = levelNames.parentLevelName || 'Parent';
    this.childLevelLabel = levelNames.childLevelName || 'Child';
    // this.grandchildLevelName=levelNames.grandchildLevelName|| "GrandChild";
    // this.stationLabel = this.childLevelLabel;
    console.log('Assigned childLevelLabel:', this.childLevelLabel);
  } else {
    console.warn('Level names are null or undefined!');
  }
  }

  toast(){
    this.snackbar.showNotification('snackbar-success', 'hellow world!')

  }

  submit() {
    const parishId = this.tokenStorage.getUser().parishId;
    const payload = {
      ...this.addStationForm.value,
      parishId: parishId
    };
    this.deptService
      .addOutstation(payload)
      .pipe()
      .subscribe(
        (res) => {
          console.log("Response = ",res);
            this.snackbar.showNotification('snackbar-success', 'Oustation added successfully!');
            this.dialogRef.close(true);
        },
        (err) => {
          console.log("Error ", err);
          this.snackbar.showNotification('snackbar-danger', 'Outstation upload failure!');
        }
      );
  }

 
  createForm(): FormGroup {
    return this.fb.group({
      outStationName: ["", Validators.required], 
      outStationLocation: ["", Validators.required],
    });
  }

 
  onClick(): void {
    this.dialogRef.close();
  }
  
  public confirmAdd(): void {
    // this.employeesService.addEmployees(this.employeesForm.getRawValue());
  }
}
